import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash/lang';

export default class FormErrors extends React.Component {
  render() {
    const {errors} = this.props;

    return (
      <div className="form-errors">
        {!isEmpty(errors) &&
          Object.entries(errors).map(([k, err], idx) => (
            <div key={idx} className="alert alert-danger">
              `{k}`: {err}
            </div>
          ))}
      </div>
    );
  }
}

FormErrors.propTypes = {
  errors: PropTypes.object.isRequired,
};
